import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const modalDescription = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
    marginBottom: space.s24,
    display: 'flex',
    flexDirection: 'column',
    gap: space.s16,
  },
]);

export const actionsContainer = style({
  display: 'flex',
  justifyContent: 'center',
  marginTop: space.s32,
});

export const docLink = style([
  typography.bodyMd,
  {
    color: themeVars.link.idle,
    ':hover': {
      textDecoration: 'underline',
    },
  },
]);
